import type { Props } from './Svg'
import { Svg } from './Svg'

export function CopyIcon(props: Props) {
  return (
    <Svg width="16" height="16" strokeWidth="0.5" fill="currentColor" {...props}>
      <path d="M14.7 12h-1.4v-1.3h1.4V1.3H5.3v1.4H4V1.3C4 .6 4.6 0 5.3 0h9.4c.7 0 1.3.6 1.3 1.3v9.4c0 .7-.6 1.3-1.3 1.3ZM12 14.7V5.3c0-.7-.6-1.3-1.3-1.3H1.3C.6 4 0 4.6 0 5.3v9.4c0 .7.6 1.3 1.3 1.3h9.4c.7 0 1.3-.6 1.3-1.3Zm-1.3 0H1.3V5.3h9.4v9.4Z" />
    </Svg>
  )
}
